import { render, staticRenderFns } from "./AlertExedsQuantity.vue?vue&type=template&id=0ef451cf"
import script from "./AlertExedsQuantity.vue?vue&type=script&lang=js"
export * from "./AlertExedsQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports